import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const dummyData = [
    { id: 1, name: 'John Doe', ip: '192.168.1.0', createdDate: '2024-05-01', email: 'john@example.com', phone: '1234567890', accountStatus: 'Active', documentStatus: 'Approved' },
    { id: 2, name: 'Jane Smith', ip: '192.168.1.0', createdDate: '2024-05-10', email: 'jane@example.com', phone: '0987654321', accountStatus: 'Inactive', documentStatus: 'Pending' },
    { id: 3, name: 'Alice Brown', ip: '192.168.1.0', createdDate: '2024-05-15', email: 'alice@example.com', phone: '5551234567', accountStatus: 'Active', documentStatus: 'Approved' },
    { id: 4, name: 'Bob White', ip: '192.168.1.0', createdDate: '2024-05-20', email: 'bob@example.com', phone: '4449876543', accountStatus: 'Inactive', documentStatus: 'Pending' }
];

const ManageAccounts = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState(dummyData);

    const filterData = () => {
        let filtered = dummyData;
        if (startDate) {
            filtered = filtered.filter((row) => new Date(row.createdDate) >= new Date(startDate));
        }
        if (endDate) {
            filtered = filtered.filter((row) => new Date(row.createdDate) <= new Date(endDate));
        }
        setData(filtered);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {/* <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        //  onClick={() => EditUiElement(rowData)}
                        className="p-button-rounded p-button-primary mr-2"
                    /> */}
                    <Button
                        tooltip="View Details"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        //   onClick={() => ViewUiElement(rowData)}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Account Approval</h3>
                <div className="flex gap-2">
                    <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} placeholder="Start Date" dateFormat="yy-mm-dd" showIcon />
                    <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} placeholder="End Date" dateFormat="yy-mm-dd" showIcon />
                    {/* <Button label="Filter" icon="pi pi-filter" onClick={filterData} className="p-button-sm" /> */}
                    <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" />
                </div>
            </div>
            <DataTable value={data} paginator rows={5} className="p-datatable-sm">
                <Column field="id" header="SL" body={(rowData, options) => options.rowIndex + 1} style={{ width: '60px' }} />
                <Column field="name" header="Owner Name" />
                <Column field="name" header="Company Email" />
                <Column field="name" header="Company Name" />
                <Column field="name" header="Company Phone" />
                <Column field="name" header="Approved Docs" />
                <Column field="name" header="Pending Docs" />
                {/* <Column field="email" header="Merchant Phone" /> */}
                {/* <Column field="createdDate" header="Created Date" /> */}
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default ManageAccounts;
